import { TooltipHost } from '@fluentui/react';
import React from 'react';
import { Color } from '../../const/Const';
import { PersonalImormationIcon, FamilyIcon, ApartmentIcon, MembershipIcon, DisabilityIcon, MilitaryServiceIcon, DriverLicenseIcon, SalaryIcon, HiredIcon, TerminatedIcon, ShiftIcon, SalaryChangeIcon, InsuretypeChangeIcon, LaborConditionChangedIcon, VacancyIcon, WorkedYearIcon, AdditionalIcon, SchoolIcon, CertificateIcon, DegreeIcon, LanguageIcon, QualificationIcon, SkillsIcon, CreationIcon, RewardIcon, EthicalIcon } from '../../svg/ReportDocIcons';

const ReportDoc = (props) => {

    let DocIcon = null;

    switch (props?.data?.name) {
        case "Хувь хүний мэдээлэл": DocIcon = PersonalImormationIcon;
            break;
        case "Гэр бүл": DocIcon = FamilyIcon;
            break;
        case "Орон сууц": DocIcon = ApartmentIcon;
            break;
        case "Гишүүнчлэл": DocIcon = MembershipIcon;
            break;
        case "Хөгжлийн бэрхшээл": DocIcon = DisabilityIcon;
            break;
        case "Цэргийн алба": DocIcon = MilitaryServiceIcon;
            break;
        case "Жолооны үнэмлэх": DocIcon = DriverLicenseIcon;
            break;
        case "Цалин": DocIcon = SalaryIcon;
            break;
        case "Ажилд орсон": DocIcon = HiredIcon;
            break;
        case "Ажлаас гарсан": DocIcon = TerminatedIcon;
            break;
        case "Дотоод шилжилт": DocIcon = ShiftIcon;
            break;
        case "Цалинд өөрчлөлт орсон": DocIcon = SalaryChangeIcon;
            break;
        case "Даатгуулагчийн төрөл өөрчлөгдсөн": DocIcon = InsuretypeChangeIcon;
            break;
        case "Хөдөлмөрийн нөхцөл өөрчлөгдсөн": DocIcon = LaborConditionChangedIcon;
            break;
        case "Орон тооны төлөвлөгөө гүйцэтгэл": DocIcon = VacancyIcon;
            break;
        case "Ажилласан жил": DocIcon = WorkedYearIcon;
            break;
        case "Нэмэгдэл": DocIcon = AdditionalIcon;
            break;
        case "Сургууль": DocIcon = SchoolIcon;
            break;
        case "Гэрчилгээ": DocIcon = CertificateIcon;
            break;
        case "Зэрэг, цол": DocIcon = DegreeIcon;
            break;
        case "Хэлний мэдлэг": DocIcon = LanguageIcon;
            break;
        case "Мэргэшил": DocIcon = QualificationIcon;
            break;
        case "Ур чадвар": DocIcon = SkillsIcon;
            break;
        case "Бүтээл": DocIcon = CreationIcon;
            break;
        case "Шагнал": DocIcon = RewardIcon;
            break;
        case "Ёс зүйн шийтгэл": DocIcon = EthicalIcon;
            break;
        case "Сахилгын шийтгэл": DocIcon = EthicalIcon;
            break;
        default: DocIcon = SalaryIcon;
            break;
    }
    return (
        <div style={{ height: 160, width: 160, backgroundColor: Color.white, cursor: 'pointer', marginLeft: 16 }} onClick={() => props.onClick(props.data)}>
            <div style={{ height: 90, width: 160, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: Color.white }}>
                <DocIcon />
            </div>
            <div style={{ height: 70, width: 160, display: 'flex', justifyContent: 'center', backgroundColor: Color.white }}>
                <div style={{ textAlign: 'center', fontSize: 12, paddingLeft: 8, paddingRight: 8 }}>
                    {props.data.name?.length > 40 ?
                        <TooltipHost content={props.data.name}>
                            <span>{(props.data.name?.substring(0, 40) + "...")}</span>
                        </TooltipHost>
                        :
                        (props.data.name)
                    }
                </div>
            </div>
        </div>
    );
}

export default ReportDoc;